import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RenderTabs = ({ tabs }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        if (tabs) {

            const currentTabIndex = tabs.findIndex(tab => tab.sPage === location.pathname);
            if (currentTabIndex !== -1) {
                setActiveTab(currentTabIndex);
            }
        }
    }, [location, tabs]);

    const handleTabClick = (tabIndex, navigationPath) => {
        setActiveTab(tabIndex);
        navigate(navigationPath);
    };

    return (
        <>
            {tabs && tabs.length > 0 &&
                <div className="row">
                    <div className="col-12">
                        <div className="tab-section mb-0">
                            <div className="tab-header">
                                {tabs?.map((tab, index) => (
                                    <button
                                        key={index + 1}
                                        className={activeTab === index ? "active" : ""}
                                        onClick={() => handleTabClick(index, tab.sPage)}
                                    >
                                        {tab.sMenuItemCaption}
                                    </button>
                                ))}
                            </div>
                            {activeTab !== -1 && tabs[activeTab].component && (
                                <div className="tab-content">
                                    <div className="tab-body-section">
                                        {tabs[activeTab].component}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

RenderTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            sPage: PropTypes.string.isRequired,
            sMenuItemCaption: PropTypes.string.isRequired,
            component: PropTypes.element,
        })
    ).isRequired,
};

export default RenderTabs